module.exports = __webpack_public_path__ + "img/A58A0029_min.61c44ad0.jpg";